/** 查新报告完成后的首次任务奖励接入 service。 */
export interface NoveltySearchReportValueOnboardingService {
    /** 订阅报告生成完成事件并启用当前页面的奖励能力。重复调用不会重复订阅。 */
    initialize(): Promise<void>;
    /** 仅在本地开发环境强制启动指定报告的奖励能力。 */
    debugStart(taskId: string): void;
    /** 销毁报告事件订阅、领取上下文和权益卡片。 */
    destroy(): void;
}

/** 查新报告首次任务奖励接入 service 的容器标识。 */
export const NoveltySearchReportValueOnboardingService = Symbol('NoveltySearchReportValueOnboardingService');
